import { useCallback, useEffect, useState } from "react"
import authInstance from "../utilities/axios/authInstance";
import { handleError } from "../utilities/errorHandler";

const useIncidentDetail = (id, handleMessage) => { // Accept handleMessage as an argument 
    const [incident, setIncident] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    const fetchDetail = useCallback(async () => {
        setLoading(true);
        try {
            const response = await authInstance.get(`/incidents/${id}`);
            setIncident(response.data);
        } catch (error) {
            // Use the custom error handler utility 
            const errorMessage = handleError(error);
            if (errorMessage && handleMessage) {
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setLoading(false);
        }
    }, [id, handleMessage]);

    const updateIncident = async (data) => {
        setSubmitting(true);
        try {
            const response = await authInstance.patch(`/incidents/${id}`, data);
            setIncident(response.data.incident);
            return {success: true};
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage && handleMessage) {
                handleMessage(errorMessage.text, 'danger');
            }

            return {success: false};
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        if (id) fetchDetail();
    }, [id, fetchDetail]);

    return { incident, loading, submitting, updateIncident, refresh: fetchDetail };
};

export default useIncidentDetail;